/**
 * Returns a random key
 *
 * @param {*} pre
 */
export const generateKey = (pre = '') => {
    return `${pre}_${Math.random()}`;
};

/**
 * @param classes
 * @returns {string}
 */
export const getClassNames = (...classes) => classes.filter(Boolean).join(' ');
